import React from 'react';

import {
  ContainerBlankVideo,
  TitleBlankVideo,
} from './style';

const BlankVideo = () => (
  <ContainerBlankVideo>
    <TitleBlankVideo>
      Add clips below to generate a highlight reel
    </TitleBlankVideo>
  </ContainerBlankVideo>
);

export default BlankVideo;
